import React, { useEffect, useState } from 'react';
import { MailIcon, MapPinIcon, LinkedinIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
function PrivacyPolicyModal({
  onClose
}: {
  onClose: () => void;
}) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-66">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-67">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 shrink-0" data-id="element-68">
          <h2 className="text-xl font-heading font-bold text-brand-navy" data-id="element-69">
            Política de Privacidad y Protección de Datos
          </h2>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer border-none" aria-label="Cerrar" data-id="element-70">
            <XIcon className="w-5 h-5 text-gray-600" data-id="element-71" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto px-8 py-6 text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-72">
          <section data-id="element-73">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-74">
              1. INTRODUCCIÓN
            </h3>
            <p data-id="element-75">
              En REDORG valoramos y respetamos la privacidad de nuestros
              usuarios. Esta Política de Privacidad describe cómo recopilamos,
              utilizamos, almacenamos y protegemos los datos personales que
              usted nos proporciona al utilizar nuestros sitios, APPs,
              terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>
          </section>

          <section data-id="element-76">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-77">
              2. RESPONSABLE DEL TRATAMIENTO
            </h3>
            <ul className="space-y-1 ml-1" data-id="element-78">
              <li data-id="element-79">
                <strong data-id="element-80">Nombre de la entidad:</strong> Fundación REDORG
              </li>
              <li data-id="element-81">
                <strong data-id="element-82">Dirección Legal:</strong> Edificio The Point, Oficina
                1803, Puerto Santa Ana, Guayaquil, Ecuador.
              </li>
              <li data-id="element-83">
                <strong data-id="element-84">Correo electrónico de contacto:</strong>{' '}
                protecciondatos@redorg.net
              </li>
            </ul>
          </section>

          <section data-id="element-85">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-86">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h3>
            <p className="mb-2" data-id="element-87">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-88">
              <li data-id="element-89">Nombres y apellidos</li>
              <li data-id="element-90">Número de Cédula</li>
              <li data-id="element-91">Correo electrónico</li>
              <li data-id="element-92">Número de teléfono</li>
              <li data-id="element-93">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-94">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
            </ul>
          </section>

          <section data-id="element-95">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-96">
              4. FINALIDAD DEL TRATAMIENTO
            </h3>
            <p className="mb-2" data-id="element-97">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-98">
              <li data-id="element-99">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-100">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-101">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-102">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-103">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-104">Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </section>

          <section data-id="element-105">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-106">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h3>
            <p className="mb-2" data-id="element-107">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-108">
              <li data-id="element-109">Tu consentimiento expreso</li>
              <li data-id="element-110">
                El interés legítimo de REDORG para cumplir su misión
                institucional
              </li>
              <li data-id="element-111">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>
          </section>

          <section data-id="element-112">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-113">
              6. DESTINATARIOS DE LOS DATOS
            </h3>
            <p className="mb-2" data-id="element-114">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-115">
              <li data-id="element-116">Tengamos tu consentimiento previo</li>
              <li data-id="element-117">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-118">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios) con contratos que
                garantizan la protección de tus datos
              </li>
            </ul>
          </section>

          <section data-id="element-119">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-120">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h3>
            <p className="mb-2" data-id="element-121">Tienes derecho a:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-122">
              <li data-id="element-123">Acceder a tus datos personales</li>
              <li data-id="element-124">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-125">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-126">Oponerte al tratamiento</li>
              <li data-id="element-127">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-128">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-2" data-id="element-129">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <a href="mailto:protecciondatos@redorg.net" className="text-brand-royal underline hover:text-brand-navy transition-colors" data-id="element-130">
                protecciondatos@redorg.net
              </a>
            </p>
          </section>

          <section data-id="element-131">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-132">
              8. USO DE COOKIES
            </h3>
            <p data-id="element-133">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </section>

          <section data-id="element-134">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-135">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h3>
            <p data-id="element-136">
              REDORG aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </section>

          <section data-id="element-137">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-138">
              10. CONSERVACIÓN DE LOS DATOS
            </h3>
            <p data-id="element-139">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </section>

          <section data-id="element-140">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-141">
              11. CAMBIOS A ESTA POLÍTICA
            </h3>
            <p data-id="element-142">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>
          </section>

          <section data-id="element-143">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-144">
              12. AUTORIDAD DE CONTROL
            </h3>
            <p data-id="element-145">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </section>

          <section data-id="element-146">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-147">
              13. VIGENCIA
            </h3>
            <p data-id="element-148">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 20 de marzo de 2026 y permanecerá vigente hasta que
              exista una nueva versión que la reemplace.
            </p>
          </section>
        </div>
      </motion.div>
    </motion.div>;
}
function TermsModal({
  onClose
}: {
  onClose: () => void;
}) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-149">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-150">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 shrink-0" data-id="element-151">
          <h2 className="text-xl font-heading font-bold text-brand-navy" data-id="element-152">
            Términos y Condiciones de Uso Plataformas REDORG
          </h2>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer border-none" aria-label="Cerrar" data-id="element-153">
            <XIcon className="w-5 h-5 text-gray-600" data-id="element-154" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto px-8 py-6 text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-155">
          <section data-id="element-156">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-157">
              1. ACEPTACIÓN DE LOS TÉRMINOS
            </h3>
            <p data-id="element-158">
              Al acceder, navegar, registrarse o utilizar el sitio web,
              aplicación móvil o cualquier plataforma digital oficial de
              Fundación REDORG (en adelante nombrados como la "Plataforma" y
              "REDORG" respectivamente), el usuario declara haber leído,
              entendido y aceptado íntegramente los presentes Términos y
              Condiciones, así como la Política de Privacidad vigente.
            </p>
            <p className="mt-2" data-id="element-159">
              Si el usuario no está de acuerdo con estos Términos, deberá
              abstenerse de utilizar la Plataforma.
            </p>
          </section>

          <section data-id="element-160">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-161">
              2. IDENTIFICACIÓN DEL TITULAR
            </h3>
            <p data-id="element-162">
              La Plataforma es operada por REDORG, entidad sin fines de lucro
              constituida conforme a las leyes de la República del Ecuador.
            </p>
          </section>

          <section data-id="element-163">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-164">
              3. USUARIOS
            </h3>
            <p className="mb-2" data-id="element-165">Pueden utilizar la Plataforma:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-166">
              <li data-id="element-167">Personas naturales mayores de 18 años</li>
              <li data-id="element-168">
                Menores de edad bajo la responsabilidad expresa de su padre,
                madre o representante legal, especialmente en el caso de
                escuelas deportivas
              </li>
            </ul>
            <p className="mt-2" data-id="element-169">
              El usuario es responsable de la veracidad de la información
              proporcionada durante su registro.
            </p>
          </section>

          <section data-id="element-170">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-171">
              4. SERVICIOS OFRECIDOS
            </h3>
            <p className="mb-2" data-id="element-172">La Plataforma permite, entre otros:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-173">
              <li data-id="element-174">
                Administración de organizaciones, aliados, socios y adherentes.
              </li>
              <li data-id="element-175">Administración y venta de productos y servicios.</li>
              <li data-id="element-176">
                Inscripción para eventos, capacitaciones, actividades u otros.
              </li>
              <li data-id="element-177">
                Pago de mensualidades, matrículas y otros valores relacionados
                con productos y servicios.
              </li>
              <li data-id="element-178">Acceso a contenido informativo, promocional y multimedia.</li>
              <li data-id="element-179">Otros productos y servicios.</li>
            </ul>
            <p className="mt-2" data-id="element-180">
              REDORG se reserva el derecho de modificar, suspender o eliminar
              servicios sin previo aviso.
            </p>
          </section>

          <section data-id="element-181">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-182">
              5. REGISTRO Y CUENTAS
            </h3>
            <p className="mb-2" data-id="element-183">
              Para acceder a ciertos servicios, el usuario deberá crear una
              cuenta proporcionando información veraz y actualizada.
            </p>
            <p className="mb-2" data-id="element-184">El usuario es responsable de:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-185">
              <li data-id="element-186">Mantener la confidencialidad de su usuario y contraseña.</li>
              <li data-id="element-187">Todas las actividades realizadas desde su cuenta.</li>
            </ul>
            <p className="mt-2" data-id="element-188">
              REDORG no será responsable por el uso no autorizado de cuentas por
              negligencia del usuario.
            </p>
          </section>

          <section data-id="element-189">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-190">
              6. CONDICIONES DE VENTA – PRODUCTOS Y SERVICIOS
            </h3>
            <ul className="list-disc ml-6 space-y-1" data-id="element-191">
              <li data-id="element-192">
                Los productos y servicios están sujetos a disponibilidad de
                stock.
              </li>
              <li data-id="element-193">
                Los precios incluyen los impuestos aplicables conforme a la ley
                ecuatoriana.
              </li>
              <li data-id="element-194">
                Las imágenes son referenciales; pueden existir variaciones
                mínimas.
              </li>
              <li data-id="element-195">
                Cambios o devoluciones solo se aceptarán por defectos de
                fabricación o falta de prestación de servicio, conforme a la
                política vigente.
              </li>
            </ul>
            <p className="mt-2" data-id="element-196">
              REDORG no se responsabiliza por retrasos atribuibles a terceros
              (courier, fuerza mayor, etc.).
            </p>
          </section>

          <section data-id="element-197">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-198">
              7. PAGOS Y TRANSACCIONES
            </h3>
            <ul className="list-disc ml-6 space-y-1" data-id="element-199">
              <li data-id="element-200">
                Todos los pagos se procesan a través de plataformas seguras de
                terceros.
              </li>
              <li data-id="element-201">REDORG no almacena información bancaria sensible.</li>
              <li data-id="element-202">
                El usuario autoriza el débito de los valores correspondientes a
                los productos y servicios adquiridos.
              </li>
            </ul>
            <p className="mt-2" data-id="element-203">
              Cualquier reclamo deberá realizarse dentro de los plazos
              establecidos por la ley.
            </p>
          </section>

          <section data-id="element-204">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-205">
              8. PROPIEDAD INTELECTUAL
            </h3>
            <p data-id="element-206">
              Todo el contenido de la Plataforma (logos, escudos, textos,
              imágenes, videos, diseños, marcas y software) es propiedad
              exclusiva de REDORG o de terceros autorizados.
            </p>
            <p className="mt-2" data-id="element-207">
              Queda prohibida su reproducción, distribución o uso comercial sin
              autorización expresa y por escrito.
            </p>
          </section>

          <section data-id="element-208">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-209">
              9. USO PROHIBIDO
            </h3>
            <p className="mb-2" data-id="element-210">El usuario se compromete a no:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-211">
              <li data-id="element-212">Utilizar la Plataforma con fines ilícitos.</li>
              <li data-id="element-213">Realizar fraudes o suplantación de identidad.</li>
              <li data-id="element-214">Introducir virus, malware o códigos dañinos.</li>
              <li data-id="element-215">Afectar el funcionamiento de la Plataforma.</li>
            </ul>
            <p className="mt-2" data-id="element-216">
              El incumplimiento podrá resultar en la suspensión o cancelación
              inmediata de la cuenta.
            </p>
          </section>

          <section data-id="element-217">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-218">
              10. RESPONSABILIDAD Y LIMITACIONES
            </h3>
            <p className="mb-2" data-id="element-219">REDORG no garantiza:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-220">
              <li data-id="element-221">Disponibilidad ininterrumpida de la Plataforma.</li>
              <li data-id="element-222">Ausencia total de errores técnicos.</li>
            </ul>
            <p className="mt-2" data-id="element-223">
              El uso de la Plataforma se realiza bajo responsabilidad exclusiva
              del usuario.
            </p>
          </section>

          <section data-id="element-224">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-225">
              11. PROTECCIÓN DE DATOS PERSONALES
            </h3>
            <p data-id="element-226">
              El tratamiento de los datos personales se rige por la Política de
              Privacidad de REDORG y la normativa vigente en Ecuador.
            </p>
          </section>

          <section data-id="element-227">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-228">
              12. VIGENCIA Y MODIFICACIONES
            </h3>
            <p data-id="element-229">REDORG podrá modificar estos Términos en cualquier momento.</p>
            <p className="mt-2" data-id="element-230">
              La vigencia de estos Términos y Condiciones de Uso es desde el 20
              de marzo de 2026 y permanecerá vigente hasta que exista una nueva
              versión que la reemplace.
            </p>
          </section>

          <section data-id="element-231">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-232">
              13. LEGISLACIÓN Y JURISDICCIÓN
            </h3>
            <p data-id="element-233">
              Estos Términos se rigen por las leyes de la República del Ecuador.
            </p>
            <p className="mt-2" data-id="element-234">
              Cualquier controversia será sometida a los jueces competentes de
              la ciudad de Guayaquil.
            </p>
          </section>

          <section data-id="element-235">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-236">
              14. CONTACTO
            </h3>
            <p data-id="element-237">
              Para consultas o reclamos, el usuario puede comunicarse a través
              de los canales oficiales de REDORG disponibles en la Plataforma.
            </p>
          </section>
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-brand-navy pt-20 pb-10 border-t border-white/10" data-id="element-238">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-240">
            {/* Brand Column */}
            <div data-id="element-241">
              <div className="bg-white inline-block p-2 rounded-lg mb-6" data-id="element-242">
                <img src="https://cdn.magicpatterns.com/uploads/78sjHca3jZk8xTuZahNMSg/Logo_REDORG.png" alt="RedOrg Logo" className="h-12 w-auto object-contain" data-id="element-243" />
              </div>
              <p className="text-white/70 mb-6 leading-relaxed" data-id="element-244">
                Uniendo fuerzas por Ecuador. Apoyamos a organizaciones sin fines
                de lucro para multiplicar el impacto social.
              </p>
              <div className="flex gap-4" data-id="element-245">
                <a href="https://www.linkedin.com/company/redorgecuador/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-brand-gold hover:text-brand-navy transition-colors" data-id="element-246">
                  <LinkedinIcon className="w-5 h-5" data-id="element-247" />
                </a>
              </div>
            </div>

            {/* Contact Column */}
            <div data-id="element-248">
              <h4 className="text-white font-heading font-semibold text-lg mb-6" data-id="element-249">
                Contacto
              </h4>
              <div className="space-y-4" data-id="element-250">
                <div className="flex items-start gap-3 text-white/70" data-id="element-251">
                  <MapPinIcon className="w-5 h-5 text-brand-gold shrink-0 mt-1" data-id="element-252" />
                  <p data-id="element-253">
                    Edificio The Point, Puerto Santa Ana, Guayaquil, Guayas,
                    Ecuador
                  </p>
                </div>
                <div className="flex items-center gap-3 text-white/70" data-id="element-254">
                  <MailIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-255" />
                  <a href="mailto:contacto@redorg.net" className="hover:text-white transition-colors" data-id="element-256">
                    contacto@redorg.net
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-257">
            <p className="text-white/50 text-sm text-center md:text-left" data-id="element-258">
              &copy; {currentYear} Fundación RedOrg. Todos los derechos
              reservados.
            </p>
            <div className="flex gap-6 text-sm text-white/50" data-id="element-259">
              <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors bg-transparent border-none cursor-pointer text-white/50 text-sm" data-id="element-260">
                Términos de Uso
              </button>
              <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors bg-transparent border-none cursor-pointer text-white/50 text-sm" data-id="element-261">
                Política de Privacidad y Protección de Datos
              </button>
            </div>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-262">
        {showPrivacy && <PrivacyPolicyModal onClose={() => setShowPrivacy(false)} data-id="element-263" />}
        {showTerms && <TermsModal onClose={() => setShowTerms(false)} data-id="element-264" />}
      </AnimatePresence>
    </>;
}